export default __webpack_public_path__ + "static/media/randLogo.82d178ff.png";